<template>
  <div id="aha-gpt-touch-point" class="aha-gpt-touch-point relative">
    <div class="flex items-center justify-center gap-1">
      <aha-icon name="chatGPT" />
      <span class="text-xs">
        {{ $i18nPresenter.t('Already using ChatGPT? Try') }}
        <a
          class="text-link--primary underline font-medium"
          name="ai-panel-aha-gpt-touch-point"
          v-aha-emit-action
          @click="openAhaSlidesGPT"
        >
          AhaSlides GPT
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AhaSlidesGPTTouchPoint',
  methods: {
    openAhaSlidesGPT() {
      window.open('https://chatgpt.com/g/g-680af02c81e08191bcfc4ea11cbba343-official-ahaslides-gpt', 'AhaSlidesGPT')
    },
  },
}
</script>
